import styled from 'styled-components';

export const StoryCardContainer = styled.section`
	margin: 2rem 1rem 3.5rem;
	position: relative;
	a {
		text-decoration: none;
	}
`;
